import { CSSProperties } from 'react';

import { IsMobileState } from '../../../hooks/useMobile';

interface Props {
  balance: number | null;
  isMobile: IsMobileState;
}

export const balanceAmountColorMapper = ({ balance, isMobile }: Props): CSSProperties['color'] => {
  if (isMobile === true) {
    if (!balance) return '#FFFFFF';
    if (balance > 0) return '#18C67F';
    if (balance === 0) return '#FFFFFF';
    if (balance < 0) return '#C74545';
  }

  if (isMobile === false) {
    if (!balance) return '#000000';
    if (balance > 0) return '#00683E';
    if (balance === 0) return '#747474';
    if (balance < 0) return '#C74545';
  }

  return undefined;
};
